<template>
	<transition name="modal">
		<section>
			<header>
				<h2>Не корректный запрос!</h2>
				<p>возможно вы забыли ввести обязательные данные в поле запроса!</p>
			</header>
		</section>
	</transition>
</template>
<script>
	export default {
		name: "incorrectData"
	};
</script>
<style scoped lang="scss">
	section {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		header {
			color: #b45756;
			text-align: center;
			p {
				font-size: 16px;
			}
		}
	}
	.modal-enter-active {
		transition: all 0.3s ease;
	}
	.modal-leave-active {
		transition: all 0.3s ease;
	}
	.modal-enter, .modal-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/incorrectData.vue